import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'

export const StyledDeleteAgendaEventButton = styled(Button)(
    ({theme: {palette, spacing}}) => css`
        justify-content: flex-start;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        border-radius: 0;
        &:hover:not(:disabled) {
            background-color: ${palette.neutral['100']};
        }
    `
)
